'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _asyncToGenerator = require('@babel/runtime/helpers/asyncToGenerator');
var _regeneratorRuntime = require('@babel/runtime/regenerator');
var _awaitAsyncGenerator = require('@babel/runtime/helpers/awaitAsyncGenerator');
var _wrapAsyncGenerator = require('@babel/runtime/helpers/wrapAsyncGenerator');
var _times = require('lodash/fp/times');
var _identity = require('lodash/fp/identity');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _objectSpread = require('@babel/runtime/helpers/objectSpread');
var _isPlainObject = require('lodash/fp/isPlainObject');
var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var _fromPairs = require('lodash/fp/fromPairs');
var _taggedTemplateLiteral = require('@babel/runtime/helpers/taggedTemplateLiteral');
var _typeof = require('@babel/runtime/helpers/typeof');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _isFunction = require('lodash/fp/isFunction');
var _find = require('lodash/fp/find');
var _reverse = require('lodash/fp/reverse');
var _get = require('lodash/fp/get');
var _unset = require('lodash/fp/unset');
var polished = require('polished');
var react = require('react');
var styled = require('styled-components');
var emotion = require('emotion');
var _map = require('lodash/fp/map');
var _filter = require('lodash/fp/filter');
var _each = require('lodash/fp/each');
var _concat = require('lodash/fp/concat');
var _assign = require('lodash/fp/assign');
var _2 = require('lodash/fp/__');
var _set = require('lodash/fp/set');
var _update = require('lodash/fp/update');
var _toPath = require('lodash/fp/toPath');
var _pullAt = require('lodash/fp/pullAt');
var _curry = require('lodash/fp/curry');
var _last = require('lodash/fp/last');
var _isEqual = require('lodash/fp/isEqual');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
var _awaitAsyncGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_awaitAsyncGenerator);
var _wrapAsyncGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_wrapAsyncGenerator);
var _times__default = /*#__PURE__*/_interopDefaultLegacy(_times);
var _identity__default = /*#__PURE__*/_interopDefaultLegacy(_identity);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var _isPlainObject__default = /*#__PURE__*/_interopDefaultLegacy(_isPlainObject);
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _fromPairs__default = /*#__PURE__*/_interopDefaultLegacy(_fromPairs);
var _taggedTemplateLiteral__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteral);
var _typeof__default = /*#__PURE__*/_interopDefaultLegacy(_typeof);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _isFunction__default = /*#__PURE__*/_interopDefaultLegacy(_isFunction);
var _find__default = /*#__PURE__*/_interopDefaultLegacy(_find);
var _reverse__default = /*#__PURE__*/_interopDefaultLegacy(_reverse);
var _get__default = /*#__PURE__*/_interopDefaultLegacy(_get);
var _unset__default = /*#__PURE__*/_interopDefaultLegacy(_unset);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var _map__default = /*#__PURE__*/_interopDefaultLegacy(_map);
var _filter__default = /*#__PURE__*/_interopDefaultLegacy(_filter);
var _each__default = /*#__PURE__*/_interopDefaultLegacy(_each);
var _concat__default = /*#__PURE__*/_interopDefaultLegacy(_concat);
var _assign__default = /*#__PURE__*/_interopDefaultLegacy(_assign);
var _2__default = /*#__PURE__*/_interopDefaultLegacy(_2);
var _set__default = /*#__PURE__*/_interopDefaultLegacy(_set);
var _update__default = /*#__PURE__*/_interopDefaultLegacy(_update);
var _toPath__default = /*#__PURE__*/_interopDefaultLegacy(_toPath);
var _pullAt__default = /*#__PURE__*/_interopDefaultLegacy(_pullAt);
var _curry__default = /*#__PURE__*/_interopDefaultLegacy(_curry);
var _last__default = /*#__PURE__*/_interopDefaultLegacy(_last);
var _isEqual__default = /*#__PURE__*/_interopDefaultLegacy(_isEqual);

function createSinglePromiseQueue() {
  return _createSinglePromiseQueue.apply(this, arguments);
}

function _createSinglePromiseQueue() {
  _createSinglePromiseQueue = _wrapAsyncGenerator__default['default'](
  /*#__PURE__*/
  _regeneratorRuntime__default['default'].mark(function _callee() {
    var lastPromise, resolve;
    return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            lastPromise = Promise.resolve();
            /* eslint-disable no-await-in-loop */

          case 1:

            _context.next = 4;
            return _awaitAsyncGenerator__default['default'](lastPromise);

          case 4:
            resolve = _identity__default['default'];
            lastPromise = new Promise(function (res) {
              resolve = res;
            });
            _context.next = 8;
            return resolve;

          case 8:
            _context.next = 1;
            break;

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _createSinglePromiseQueue.apply(this, arguments);
}

function createPromiseQueue() {
  return _createPromiseQueue.apply(this, arguments);
}

function _createPromiseQueue() {
  _createPromiseQueue = _wrapAsyncGenerator__default['default'](
  /*#__PURE__*/
  _regeneratorRuntime__default['default'].mark(function _callee3() {
    var parallel,
        queues,
        promises,
        locks,
        getNextAvailableLock,
        lock,
        _args3 = arguments;
    return _regeneratorRuntime__default['default'].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            parallel = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : 1;
            queues = _times__default['default'](createSinglePromiseQueue, parallel);
            promises = queues.map(function (q) {
              return q.next();
            });
            _context3.next = 5;
            return _awaitAsyncGenerator__default['default'](Promise.all(promises));

          case 5:
            locks = _context3.sent;

            getNextAvailableLock =
            /*#__PURE__*/
            function () {
              var _ref = _asyncToGenerator__default['default'](
              /*#__PURE__*/
              _regeneratorRuntime__default['default'].mark(function _callee2() {
                var index, lock;
                return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        index = locks.findIndex(Boolean);

                        if (!(index >= 0)) {
                          _context2.next = 6;
                          break;
                        }

                        lock = locks[index];
                        locks[index] = null;
                        promises[index] = queues[index].next().then(function (result) {
                          locks[index] = result;
                        });
                        return _context2.abrupt("return", [lock.value, locks.filter(Boolean).length]);

                      case 6:
                        _context2.next = 8;
                        return Promise.race(promises);

                      case 8:
                        return _context2.abrupt("return", getNextAvailableLock());

                      case 9:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, this);
              }));

              return function getNextAvailableLock() {
                return _ref.apply(this, arguments);
              };
            }();

          case 7:

            _context3.next = 10;
            return _awaitAsyncGenerator__default['default'](getNextAvailableLock());

          case 10:
            lock = _context3.sent;
            _context3.next = 13;
            return lock;

          case 13:
            _context3.next = 7;
            break;

          case 15:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));
  return _createPromiseQueue.apply(this, arguments);
}

var getClosestOffsetScroll = function getClosestOffsetScroll(node) {
  if (!node) {
    return document.body;
  }

  var overflowY = window.getComputedStyle(node).overflowY;
  var isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';

  if (isScrollable && node.scrollHeight > node.clientHeight) {
    return node;
  } else {
    return getClosestOffsetScroll(node.offsetParent);
  }
};

// Get the top position of an element in the document
var getTop = function getTop(element, start) {
  // return value of html.getBoundingClientRect().top ... IE : 0, other browsers : -pageYOffset
  if (!element || element.nodeName === 'HTML') return -start;
  return element.getBoundingClientRect().top + start;
}; // ease in out function thanks to:
// http://blog.greweb.fr/2012/02/bezier-curve-based-easing-functions-from-concept-to-implementation/


var easeInOutCubic = function easeInOutCubic(t) {
  return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
}; // calculate the scroll position we should be in
// given the start and end point of the scroll
// the time elapsed from the beginning of the scroll
// and the total duration of the scroll (default 500ms)


var position = function position(start, end, elapsed, duration) {
  if (elapsed > duration) return end;
  return start + (end - start) * easeInOutCubic(elapsed / duration); // <-- you can change the easing funtion there
  // return start + (end - start) * (elapsed / duration); // <-- this would give a linear scroll
}; // we use requestAnimationFrame to be called by the browser before every repaint
// if the first argument is an element then scroll to the top of this element
// if the first argument is numeric then scroll to this location
// if the callback exist, it is called when the scrolling is finished
// if context is set then scroll that element, else scroll window


var smoothScroll = function smoothScroll(el) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var callback = arguments.length > 2 ? arguments[2] : undefined;
  var ctx = arguments.length > 3 ? arguments[3] : undefined;
  var context = ctx || window;
  var start = context.scrollTop || window.pageYOffset;
  var offset = el instanceof HTMLElement ? 0 : el.offset || 0;
  var end = offset + (typeof el === 'number' ? Math.round(el) : el instanceof HTMLElement ? getTop(el, start) : getTop(el.target, start));
  var clock = Date.now();

  var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function (fn) {
    window.setTimeout(fn, 15);
  };

  var step = function step() {
    var elapsed = Date.now() - clock;

    if (context !== window) {
      context.scrollTop = position(start, end, elapsed, duration);
    } else {
      window.scroll(window.pageXOffset, position(start, end, elapsed, duration));
    }

    if (elapsed > duration) {
      if (typeof callback === 'function') {
        callback(el);
      }
    } else {
      requestAnimationFrame(step);
    }
  };

  step();
};

var fixed = false;
var scrollWidth = function () {
  if (!window.document) return 0;
  var html = document.documentElement;
  var oldOverflow = html.style.overflowY;
  html.style.overflowY = 'scroll';
  var width = window.innerWidth - html.clientWidth;
  html.style.overflowY = oldOverflow;
  return width;
}();

var fixMediaQueryFn = function fixMediaQueryFn() {
  var fontSize = parseFloat(window.getComputedStyle(document.body).getPropertyValue('font-size'));

  if (scrollWidth > 0) {
    [].slice.call(document.styleSheets).filter(function (styleSheet) {
      return isValidExternal(styleSheet) || isInline(styleSheet);
    }).forEach(function (stylesheet) {
      try {
        [].slice.call(stylesheet.cssRules || stylesheet.media).filter(function (rule) {
          return rule.constructor === window.CSSMediaRule;
        }).forEach(function (rule) {
          rule.media.mediaText = rule.media.mediaText.replace(/m(in|ax)-width:\s*(\d|\.)+(px|em)/gi, function (strA) {
            if (strA.match('px')) {
              return strA.replace(/\d+px/gi, function (strB) {
                return parseInt(strB, 10) + scrollWidth + 'px';
              });
            } else {
              return strA.replace(/\d.+?em/gi, function (strB) {
                return (parseFloat(strB) * fontSize + scrollWidth) / fontSize + 'em';
              });
            }
          });
        });
      } catch (e) {}
    });
  }

  fixed = true;

  function sameOrigin(url) {
    var loc = window.location,
        a = document.createElement('a');
    a.href = url;
    return a.hostname === loc.hostname && a.protocol === loc.protocol;
  }

  function isInline(stylesheet) {
    try {
      return stylesheet.ownerNode.constructor === HTMLStyleElement && stylesheet.ownerNode.getAttribute("data-styled") === null;
    } catch (e) {
      return stylesheet.ownerNode.constructor === HTMLStyleElement;
    }
  }

  function isValidExternal(stylesheet) {
    var _stylesheet$ownerNode;

    return stylesheet.href && (sameOrigin(stylesheet.href) || ((_stylesheet$ownerNode = stylesheet.ownerNode) === null || _stylesheet$ownerNode === void 0 ? void 0 : _stylesheet$ownerNode.crossOrigin) === "anonymous");
  }
};

function fixMediaQuery() {
  if (fixed || !document || !document.readyState) return;

  if (process.env.NODE_ENV === 'test') {
    return;
  }

  if (document.readyState !== 'loading') {
    fixMediaQueryFn();
  } else {
    document.addEventListener('DOMContentLoaded', fixMediaQueryFn);
  }
}

var formatPath = function formatPath() {
  for (var _len = arguments.length, paths = new Array(_len), _key = 0; _key < _len; _key++) {
    paths[_key] = arguments[_key];
  }

  return paths.map(function (path) {
    return Array.isArray(path) ? path.join('.') : path ? path.toString().replace(/\[/g, '.').replace(/]/g, '') : '';
  }).filter(function (_) {
    return _;
  }).join('.');
};
var identityFn = function identityFn() {
  var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return function () {
    for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      e[_key2] = arguments[_key2];
    }

    return e[n];
  };
};
var will = function will(fn) {
  for (var _len3 = arguments.length, props = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    props[_key3 - 1] = arguments[_key3];
  }

  return function () {
    for (var _len4 = arguments.length, more = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      more[_key4] = arguments[_key4];
    }

    return fn.apply(void 0, props.concat(more));
  };
};
var unWill = function unWill(fn) {
  for (var _len5 = arguments.length, props = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    props[_key5 - 1] = arguments[_key5];
  }

  return function () {
    return fn.apply(void 0, props);
  };
};
var lazyValue = function lazyValue(v) {
  return function () {
    return v;
  };
};
var callIfFunction = function callIfFunction(prop) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    args[_key6 - 1] = arguments[_key6];
  }

  return typeof prop === "function" ? prop.apply(void 0, args) : prop;
};
var callIfFunctions = function callIfFunctions(prop) {
  for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    args[_key7 - 1] = arguments[_key7];
  }

  return typeof prop === "function" ? prop.apply(void 0, _toConsumableArray__default['default'](args.map(function (e) {
    return callIfFunction(e);
  }))) : prop;
};
var callMany = function callMany() {
  for (var _len8 = arguments.length, many = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    many[_key8] = arguments[_key8];
  }

  return function () {
    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    return many.map(function (_) {
      return callIfFunction.apply(void 0, [_].concat(args));
    });
  };
};
var ifUndefined = function ifUndefined(v) {
  for (var _len10 = arguments.length, or = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
    or[_key10 - 1] = arguments[_key10];
  }

  return v !== undefined ? v : or.length === 1 ? or[0] : ifUndefined.apply(void 0, [or[0]].concat(_toConsumableArray__default['default'](or.slice(1))));
};
var using = function using() {
  for (var _len11 = arguments.length, v = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
    v[_key11] = arguments[_key11];
  }

  return function (fn) {
    return fn.apply(void 0, _toConsumableArray__default['default'](v.map(function (v) {
      return callIfFunction(v);
    })));
  };
};
var stopPropagation = function stopPropagation(cb) {
  return function (e) {
    e && e.stopPropagation && e.stopPropagation();
    callIfFunction(cb, e);
  };
};
var preventDefault = function preventDefault(cb) {
  return function (e) {
    e && e.preventDefault && e.preventDefault();
    callIfFunction(cb, e);
  };
};
var constrainEvent = function constrainEvent(cb) {
  return function (e) {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    e.stopPropagation();
    callIfFunction(cb, e);
  };
};
var mapGetOrSet = function mapGetOrSet(map, key, value) {
  return (map.has(key) ? map : map.set(key, value)).get(key);
};
var intToHour = function intToHour(hour) {
  var autoFill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (hour === undefined || hour === null) return '';

  if (hour === 0) {
    return "00:00";
  }

  if (autoFill) return ('000' + hour.toString().replace(":", "")).slice(-4).replace(/(\d\d)(\d\d)/, '$1:$2');
  var h = hour.toString().replace(":", "").slice(-4, -2);
  var m = hour.toString().replace(":", "").slice(-2);
  if (h) return (parseInt(h, 10) > 23 ? h.slice(1) : h) + ':' + m;
  return m;
};
var willRafThrottle = function willRafThrottle() {
  var ticking = false;
  return function (fn) {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        fn();
        ticking = false;
      });
      ticking = true;
    }
  };
};
var rafThrottle = function rafThrottle(fn) {
  var throttle = willRafThrottle();
  return function () {
    throttle(fn);
  };
};
var intsToHour = function intsToHour(_ref) {
  var open = _ref.open,
      close = _ref.close;
  return intToHour(open) + ' - ' + intToHour(close);
};
function isSmallDevice() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 600;
  var smallDeviceQuery = window.matchMedia ? window.matchMedia("(max-width: ".concat(width + scrollWidth, "px)")) : {
    matches: false
  };
  return smallDeviceQuery.matches;
}
function isHighDensity() {
  return window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches) || window.devicePixelRatio && window.devicePixelRatio > 1.3;
}
function isRetina() {
  return (window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches) || window.devicePixelRatio && window.devicePixelRatio >= 2) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
}
function isMobile() {
  var check = false;

  if (typeof navigator === 'undefined') {
    return false;
  }

  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series([46])0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br([ev])w|bumb|bw-([nu])|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do([cp])o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly([-_])|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-([mpt])|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c([- _agpst])|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac([ -/])|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja([tv])a|jbro|jemu|jigs|kddi|keji|kgt([ /])|klon|kpt |kwc-|kyo([ck])|le(no|xi)|lg( g|\/([klu])|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t([- ov])|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30([02])|n50([025])|n7(0([01])|10)|ne(([cm])-|on|tf|wf|wg|wt)|nok([6i])|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan([adt])|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c([-01])|47|mc|nd|ri)|sgh-|shar|sie([-m])|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c([- ])|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window['opera']);

  return check;
}
function isTouchDevice() {
  return window.document && 'ontouchstart' in window.document.documentElement;
}
var isIOS = function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
};
var getNumberInputType2 = function getNumberInputType2() {
  var isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
  return isMobile() ? isIOS ? "tel" : "number" : "text";
};
var getNumberInputType = function getNumberInputType() {
  return "tel";
};
function addHttp(s) {
  s = (s || '').trim();

  if (s.indexOf('http://') === 0 || s.indexOf('https://') === 0) {
    return s;
  } else {
    return 'http://' + s;
  }
}
var protocols = "(^|\\s|\xA0)(https?://)?(www\\.)?";
var subdomains = '([a-zA-Z0-9][a-zA-Z0-9-_]*[a-zA-Z0-9]?\\.)*';
var domain = '(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9]))\\.([a-zA-Z]{2,6}|[a-zA-Z0-9-]{2,30}\\.[a-zA-Z]{2,3})';
var resource = "[\xA1-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEFa-zA-Z0-9-._~:/?#%[\\]@!$&'()*+,;=]*";
var linkRegex = new RegExp(protocols + subdomains + domain + resource);
function isUrl(url) {
  return linkRegex.test(addHttp(url));
}
function ellipsis() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var length = arguments.length > 1 ? arguments[1] : undefined;

  if (str.length > length) {
    var words = str.slice(0, length).split(' ');
    if (str.split(' ').indexOf(words[words.length - 1]) < 0) words = words.slice(0, words.length - 1);
    return words.join(' ') + '...';
  } else return str;
}
function safeNewLineToBr(str) {
  return (str || "").replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/\n+/g, '<br/>');
}

function padGroups(pattern, value) {
  return pattern.split('').reduce(function (_ref2, char, i) {
    var _ref3 = _slicedToArray__default['default'](_ref2, 2),
        acc = _ref3[0],
        value = _ref3[1];

    if (char === '0') {
      var shouldHave = pattern.slice(i).search(/[^0#?*]/);
      var has = value.slice(i).search(/\D/);

      if (has > 0 && shouldHave > has) {
        return [acc.concat('0'), acc.join('') + '0' + value.slice(i)];
      } else {
        return [acc.concat(value[i]), value];
      }
    } else {
      return [acc.concat(value[i]), value];
    }
  }, [[], value])[0].join('');
}

var digitsToPattern = function digitsToPattern(patternWithLimit, optValue) {
  var value = optValue || "";
  if (patternWithLimit[0] === '>' && Number(patternWithLimit.replace(/^>(\d*).*/g, "$1")) > value.length) return value;
  var pattern = patternWithLimit.replace(/^>\d+/, '');
  var digits = padGroups(pattern, value).replace(/\D/g, '');
  var totalRequired = pattern.split(/[0#]/).length - 1;
  var totalOptional = pattern.split(/[?*]/).length - 1;
  var available = digits.length - totalRequired;

  if (available > 0 && totalOptional > 0) {
    var _i = 0;
    return digitsToPattern(pattern.replace(/\?/g, function () {
      return _i++ < available ? '#' : '';
    }).replace('*', new Array(Math.max(0, available - _i + 1)).join("#")), value);
  }

  var i = 0;
  return pattern.replace(/^>\d*/, '').split('').reduce(function (acc, char) {
    if (!digits[Math.max(i - 1, 0)] || char === '?' || char === '*') return acc;

    if (char === '#' || char === '0') {
      return acc + (digits[i++] || '');
    } else {
      return acc + char;
    }
  }, '');
};
var normalizeTouch = function normalizeTouch(fn, endFn) {
  return function (e) {
    var touch = e.touches[0];

    if (e.touches.length > 1) {
      endFn();
    } else {
      fn(e.currentTarget, touch.pageX, touch.pageY, touch.clientX, touch.clientY, e);
    }
  };
};
var normalizeMouse = function normalizeMouse(fn) {
  return function (e) {
    fn(e.currentTarget, e.pageX, e.pageY, e.clientX, e.clientY, e);
  };
};
var isEmptyHtml = function isEmptyHtml() {
  var __html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  var a = document.createElement('span');
  a.innerHTML = __html;
  return a.textContent.replace(/\s/g, '').length === 0;
};
var getScrollParent = function getScrollParent(node) {
  if (!node) {
    return window;
  }

  var overflowY = window.getComputedStyle(node).overflowY;
  var isScrollable = overflowY !== 'visible' && overflowY !== 'hidden';

  if (isScrollable && (node.scrollHeight > node.clientHeight || overflowY === 'scroll')) {
    return node;
  } else {
    return getScrollParent(node.offsetParent);
  }
};
var scrollIntoViewWithOffset = function scrollIntoViewWithOffset(el, offset) {
  var scrollOffset = getScrollParent(el);
  var scrollY = scrollOffset === window ? window.pageYOffset : scrollOffset.scrollTop;
  var elTop = el.getBoundingClientRect().top;
  var computedOffset = callIfFunction(offset, elTop > 0);
  var y = el.getBoundingClientRect().top + scrollY + computedOffset;
  scrollOffset.scrollTo({
    top: y,
    behavior: 'smooth'
  });
};
var timerPromise = function timerPromise(time) {
  return new Promise(function (res) {
    return setTimeout(res, time);
  });
};
var i = 0;
var getUID = function getUID() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2) + (i++).toString(36);
};
var getUrlParams = function getUrlParams() {
  return _fromPairs__default['default'](Array.from(new URLSearchParams(location.search).entries()));
};

var resolveFetch =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator__default['default'](
  /*#__PURE__*/
  _regeneratorRuntime__default['default'].mark(function _callee(url, fetchOptions) {
    var response, text, json;
    return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(url, _objectSpread__default['default']({
              credentials: 'same-origin'
            }, fetchOptions));

          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.text();

          case 6:
            text = _context.sent;
            _context.prev = 7;
            json = JSON.parse(text);
            return _context.abrupt("return", [json, response]);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](7);
            return _context.abrupt("return", [text, response]);

          case 15:
            _context.next = 20;
            break;

          case 17:
            _context.prev = 17;
            _context.t1 = _context["catch"](0);
            return _context.abrupt("return", [_context.t1, false]);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 17], [7, 12]]);
  }));

  return function resolveFetch(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var innerFetcher =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator__default['default'](
  /*#__PURE__*/
  _regeneratorRuntime__default['default'].mark(function _callee2(url, fetchOptions) {
    var _ref3, _ref4, data, response;

    return _regeneratorRuntime__default['default'].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return resolveFetch(url, fetchOptions);

          case 2:
            _ref3 = _context2.sent;
            _ref4 = _slicedToArray__default['default'](_ref3, 2);
            data = _ref4[0];
            response = _ref4[1];

            if (!(!response || response.status >= 400)) {
              _context2.next = 10;
              break;
            }

            throw [data, response];

          case 10:
            return _context2.abrupt("return", [data, response]);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function innerFetcher(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

var addQueryString = function addQueryString() {
  var existingUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var obj = arguments.length > 1 ? arguments[1] : undefined;

  var _existingUrl$split = existingUrl.split('?'),
      _existingUrl$split2 = _slicedToArray__default['default'](_existingUrl$split, 2),
      onlyUrl = _existingUrl$split2[0],
      otherQueryString = _existingUrl$split2[1];

  var params = new URLSearchParams(otherQueryString);

  for (var key in obj) {
    params.set(key, obj[key]);
  }

  var paramsStr = params.toString();

  if (!paramsStr) {
    return onlyUrl;
  }

  return onlyUrl + '?' + paramsStr;
};
var postFetcherWithResponse =
/*#__PURE__*/
function () {
  var _ref5 = _asyncToGenerator__default['default'](
  /*#__PURE__*/
  _regeneratorRuntime__default['default'].mark(function _callee3(url, jsonOrForm) {
    var fetchOptions,
        _args3 = arguments;
    return _regeneratorRuntime__default['default'].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            fetchOptions = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : {};
            return _context3.abrupt("return", innerFetcher(url, _objectSpread__default['default']({
              method: 'POST',
              body: typeof jsonOrForm === 'string' ? jsonOrForm : !jsonOrForm || jsonOrForm.constructor === window.FormData ? jsonOrForm : JSON.stringify(jsonOrForm)
            }, fetchOptions, {
              headers: _isPlainObject__default['default'](fetchOptions.headers) || !fetchOptions.headers ? _objectSpread__default['default']({}, jsonOrForm && (typeof jsonOrForm === 'string' || jsonOrForm.constructor === window.FormData) ? {} : {
                'Content-Type': 'application/json; charset=UTF-8'
              }, fetchOptions.headers) : fetchOptions.headers
            })));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function postFetcherWithResponse(_x5, _x6) {
    return _ref5.apply(this, arguments);
  };
}();
var getFetcherWithResponse =
/*#__PURE__*/
function () {
  var _ref6 = _asyncToGenerator__default['default'](
  /*#__PURE__*/
  _regeneratorRuntime__default['default'].mark(function _callee4(url, jsonParams, fetchOptions) {
    return _regeneratorRuntime__default['default'].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", innerFetcher(addQueryString(url, jsonParams), _objectSpread__default['default']({
              method: 'GET'
            }, fetchOptions)));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function getFetcherWithResponse(_x7, _x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}();
var postFetcher =
/*#__PURE__*/
function () {
  var _ref7 = _asyncToGenerator__default['default'](
  /*#__PURE__*/
  _regeneratorRuntime__default['default'].mark(function _callee5(url, json, options) {
    return _regeneratorRuntime__default['default'].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", postFetcherWithResponse(url, json, options).then(function (_ref8) {
              var _ref9 = _slicedToArray__default['default'](_ref8, 1),
                  json = _ref9[0];

              return json;
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function postFetcher(_x10, _x11, _x12) {
    return _ref7.apply(this, arguments);
  };
}();
var getFetcher =
/*#__PURE__*/
function () {
  var _ref10 = _asyncToGenerator__default['default'](
  /*#__PURE__*/
  _regeneratorRuntime__default['default'].mark(function _callee6(url, json, options) {
    return _regeneratorRuntime__default['default'].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", getFetcherWithResponse(url, json, options).then(function (_ref11) {
              var _ref12 = _slicedToArray__default['default'](_ref11, 1),
                  json = _ref12[0];

              return json;
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function getFetcher(_x13, _x14, _x15) {
    return _ref10.apply(this, arguments);
  };
}();
var formFetchWithResponse = function formFetchWithResponse(url, options) {
  return function (values, meta) {
    return postFetcherWithResponse(callIfFunction(url, meta, values), values, callIfFunction(options, meta, values));
  };
};
var formFetch = function formFetch(url, options) {
  return function (values, meta) {
    return postFetcher(callIfFunction(url, meta, values), values, callIfFunction(options, meta, values));
  };
};

var moveElement = _curry__default['default'](function (from, to, list) {
  var el = list[from];

  var without = _pullAt__default['default'](from, list);

  without.splice(to, 0, el);
  return without;
});
var unsetOrRemoveAt = _curry__default['default'](function (path, value) {
  var pathArr = toPath(path);

  var _pathArr$slice = pathArr.slice(-1),
      _pathArr$slice2 = _slicedToArray__default['default'](_pathArr$slice, 1),
      lastKey = _pathArr$slice2[0];

  return update(pathArr.slice(0, -1), function (v) {
    return Array.isArray(v) ? removeAt(lastKey, v) : unset(lastKey, v);
  }, value);
});
var pathToString = function pathToString(path) {
  return toPath(path).join(".");
};

var sanitizePath = function sanitizePath(path) {
  return Array.isArray(path) ? path.map(sanitizePath) : typeof path === 'number' ? path.toString() : path === undefined ? [] : path;
};

var toPath = function toPath(path) {
  return _toPath__default['default'](sanitizePath(path));
};

var isEmptyPath = function isEmptyPath(path) {
  return path && !path.length;
};

var update = _curry__default['default'](function (path, updater, state) {
  var sanitizedPath = sanitizePath(path);

  if (isEmptyPath(sanitizedPath)) {
    return updater(state);
  } else {
    return _update__default['default'](sanitizedPath, updater, state);
  }
});
var get = _curry__default['default'](function (path, state) {
  var sanitizedPath = sanitizePath(path);

  if (isEmptyPath(sanitizedPath)) {
    return state;
  } else {
    return _get__default['default'](sanitizedPath, state);
  }
});
var set = _curry__default['default'](function (path, value, state) {
  var sanitizedPath = sanitizePath(path);

  if (isEmptyPath(sanitizedPath)) {
    return value;
  } else {
    return _set__default['default'](sanitizedPath, value, state);
  }
});
var unset = _curry__default['default'](function (path, state) {
  var sanitizedPath = sanitizePath(path);

  if (isEmptyPath(sanitizedPath)) {
    return undefined;
  } else {
    return _unset__default['default'](sanitizedPath, state);
  }
});
var removeNAt = _curry__default['default'](function (pos, n, value) {
  return _toConsumableArray__default['default'](value.slice(0, Number(pos))).concat(_toConsumableArray__default['default'](value.slice(Number(pos) + n)));
});
var removeAt = removeNAt(_2__default['default'], 1);
var when = _curry__default['default'](function (cond, fn, value) {
  return callIfFunction(cond, value) ? fn(value) : value;
});
var assign = _curry__default['default'](function (a, b) {
  return _assign__default['default'](b, a);
});
var concat = _curry__default['default'](function (a, b) {
  return _concat__default['default'](b, a);
});
var each = _each__default['default'].convert({
  cap: false
});
var find = _find__default['default'].convert({
  cap: false
});
var filter = _filter__default['default'].convert({
  cap: false
});
var map = _map__default['default'].convert({
  cap: false
});
var insertAt = _curry__default['default'](function (pos, newElements, value) {
  return _toConsumableArray__default['default'](value.slice(0, pos).concat(newElements)).concat(_toConsumableArray__default['default'](value.slice(pos)));
});
var _s = {
  moveElement: moveElement,
  unsetOrRemoveAt: unsetOrRemoveAt,
  pathToString: pathToString,
  toPath: toPath,
  update: update,
  get: get,
  set: set,
  unset: unset,
  removeNAt: removeNAt,
  removeAt: removeAt,
  when: when,
  assign: assign,
  concat: concat,
  each: each,
  find: find,
  filter: filter,
  map: map,
  insertAt: insertAt
};

function _templateObject() {
  var data = _taggedTemplateLiteral__default['default'](["\n  ", ""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var getColor = function getColor(propsOrColor, hover) {
  if (typeof propsOrColor === 'string') {
    return function (_ref) {
      var theme = _ref.theme;
      return theme.colors[propsOrColor];
    };
  }

  var theme = propsOrColor.theme,
      props = _objectWithoutProperties__default['default'](propsOrColor, ["theme"]);

  if (props.dark) {
    return polished.darken(0.1, getColor(_objectSpread__default['default']({
      theme: theme
    }, _unset__default['default']('dark', props))));
  } else if (hover && props.hover) {
    return getColor({
      theme: theme,
      color: props.hover
    });
  } else if (props.color) {
    return theme.colors[props.color] || props.color;
  } else if (props.highlight) {
    return theme.colors.main;
  } else if (props.alert) {
    return theme.colors.alert;
  } else if (props.success) {
    return theme.colors.success;
  } else {
    return theme.colors.gray150;
  }
};
var getMargin = function getMargin(enumeratedMargins) {
  return function (props) {
    return enumeratedMargins[props.margin] || props.margin || enumeratedMargins['default'] || 0;
  };
};
/**
 * Returns the value of `props[path]` or `defaultValue`
 * @example
 * const Button = styled.button`
 *  color: ${prop('color', 'red')};
 * `
 */

var getProp = function getProp(path, defaultValue) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return get([].concat(path), props) || defaultValue;
  };
};
var customTheme = function customTheme(type) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _get__default['default'](["theme", "startlibs", type], props) || '';
  };
};
/**
 * Returns `pass` if prop is truthy. Otherwise returns `fail`
 * @example
 * // usage with styled-theme
 * import styled from 'styled-components'
 * import { ifProp } from 'styled-tools'
 * import { palette } from 'styled-theme'
 *
 * const Button = styled.button`
 *  background-color: ${ifProp('transparent', 'transparent', palette(0))};
 *  color: ${ifProp(['transparent', 'accent'], palette('secondary', 0))};
 *  font-size: ${ifProp({ size: 'large' }, '20px', ifProp({ size: 'medium' }, '16px', '12px'))};
 *`
 */

var ifProp = function ifProp(path, pass, fail) {
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var result = false;

    if (Array.isArray(path)) {
      result = path.every(function (p) {
        return testSinglePath(props, p);
      });
    } else if (_typeof__default['default'](path) === 'object') {
      result = !Object.entries(path).find(function (_ref2) {
        var _ref3 = _slicedToArray__default['default'](_ref2, 2),
            k = _ref3[0],
            v = _ref3[1];

        return props[k] !== v;
      });
    } else {
      result = testSinglePath(props, path);
    }

    return result ? pass : fail;
  };
};
var media = function media() {
  for (var _len = arguments.length, sizePairs = new Array(_len), _key = 0; _key < _len; _key++) {
    sizePairs[_key] = arguments[_key];
  }

  return function () {
    return styled.css(["@media screen and ", "{", "}"], sizePairs.map(function (_ref4) {
      var _ref5 = _slicedToArray__default['default'](_ref4, 2),
          size = _ref5[0],
          type = _ref5[1];

      return "(".concat(type, ": ").concat(size + scrollWidth, "px)");
    }).join(' and '), styled.css.apply(void 0, arguments));
  };
};
media.mobile = media([600, 'max-width']);

media.between = function (min, max) {
  return media([min, 'min-width'], [max, 'max-width']);
};

media.max = function (n) {
  return media([n, 'max-width']);
};

media.min = function (n) {
  return media([n, 'min-width']);
};

media.desktop = media([601, 'min-width']);

function testSinglePath(props, path) {
  if (typeof path === 'string') {
    return !!get(path, props);
  } else if (typeof path === 'number') {
    return !!props[path];
  } else {
    return false;
  }
}

var getFrameOffset = function getFrameOffset(i, total) {
  return Math.round(i * 100 / (total - 1));
};

var oneWayAnimation = function oneWayAnimation() {
  for (var _len2 = arguments.length, frames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    frames[_key2] = arguments[_key2];
  }

  return emotion.keyframes(_templateObject(), frames.map(function (frame, i) {
    return !frame ? '' : "".concat(getFrameOffset(i, frames.length), "% {\n      ").concat(frame, "\n    }");
  }));
};
var twoWayAnimation = function twoWayAnimation() {
  for (var _len3 = arguments.length, frames = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    frames[_key3] = arguments[_key3];
  }

  return [frames, _reverse__default['default'](frames)].map(function (frames) {
    return oneWayAnimation.apply(void 0, _toConsumableArray__default['default'](frames));
  });
};
var animationTiming = function animationTiming(props) {
  return function () {
    for (var _len4 = arguments.length, animations = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      animations[_key4] = arguments[_key4];
    }

    return animations.filter(function (_) {
      return _;
    }).map(function (_) {
      return _ + ' ' + props;
    }).join(',');
  };
};
var identityTranslateFrames = oneWayAnimation('transform: translateY(0);', 'transform: translateY(0);');
var identityOpacityFrames = oneWayAnimation('opacity: 1;', 'opacity:1;');
var styledExtend = function styledExtend(_ref6) {
  var target = _ref6.target,
      componentStyle = _ref6.componentStyle;
  return function () {
    var v = styled__default['default'](target).apply(void 0, arguments);
    v.componentStyle.rules = _toConsumableArray__default['default'](componentStyle.rules).concat(_toConsumableArray__default['default'](v.componentStyle.rules));
    v.componentStyle.isStatic = !_find__default['default'](_isFunction__default['default'], v.componentStyle.rules);
    return v;
  };
};

var escapedValidParts = /(^|[^\\])(dd?|DD?|mm?|LL?|hh?|MM?|yy(?:yy)?)/g;
var validParts = /(dd?|DD?|mm?|LL?|hh?|MM?|yy(?:yy))$/;

var addZero = function addZero(v) {
  return (v < 10 ? '0' : '') + v;
};

var getSet = function getSet(index, ttype) {
  var plus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var format = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (v) {
    return v;
  };
  var parse = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (v, defaultDate) {
    return v === '0' ? '' : v;
  };
  return [function (date, _, noUTC) {
    return format((typeof date === 'number' ? new Date(date) : date)['get' + (noUTC ? '' : 'UTC') + ttype]() + plus);
  }, function (unformatedStr, date, _, failOnFormat) {
    var str = parse(unformatedStr, date, failOnFormat);
    if (str === '' || isNaN(date.getTime())) return date;
    if (str === '\0') return date.setTime(NaN);
    var v = parseInt(str, 10) - plus;
    var prevDay = date.getUTCDate();

    if (ttype !== 'Date') {
      date.setUTCDate(1);
    }

    date['setUTC' + ttype](v);

    if (date['getUTC' + ttype]() !== v) {
      date['setUTC' + ttype](NaN);
      return date;
    }

    if (ttype !== 'Date') {
      date.setUTCDate(prevDay);

      if (date['getUTC' + ttype]() !== v) {
        date.setUTCDate(0);
        return date;
      }
    }

    return date;
  }, index];
};

var getText = function getText(type, total) {
  var slice = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 99;
  return [function (date, messages, noUTC) {
    return messages(type.toLowerCase(), date['get' + (noUTC ? '' : 'UTC') + type]()).slice(0, slice);
  }];
};

var val = {
  yyyy: getSet(0, 'FullYear', 0, function (v) {
    return v;
  }, function (y, date, failOnFormat) {
    var formattedY = y.length === 2 && y !== '20' ? '20' + y : y.length === 4 ? y : '';

    if (formattedY === '') {
      if (failOnFormat) {
        var found = date.getUTCFullYear().toString().indexOf(y);
        return found === 0 || found === 2 ? date.getUTCFullYear() : '\0';
      } else {
        return date.getUTCFullYear();
      }
    } else {
      return formattedY;
    }
  }),
  M: getSet(1, 'Month', 1),
  MM: getSet(1, 'Month', 1, addZero),
  L: getText('Month', 12, 3),
  LL: getText('Month', 12),
  d: getSet(2, 'Date'),
  dd: getSet(2, 'Date', 0, addZero),
  D: getText('Day', 7, 3),
  DD: getText('Day', 7),
  m: getSet(4, 'Minutes'),
  mm: getSet(4, 'Minutes', 0, addZero),
  h: getSet(5, 'Hours'),
  hh: getSet(5, 'Hours', 0, addZero)
};
function formatDateToPattern(format) {
  return format.replace(escapedValidParts, function (_, _1, _2) {
    return _1 + (_2 === 'yy' ? '##' : _2 === 'yyyy' ? '####' : '0#');
  });
}
function formatDate(date, format, messages, noUTC) {
  if (!date) return '';
  var separators = format.replace(escapedValidParts, '\0').split('\0');
  var parts = format.match(escapedValidParts);
  var formattedDate = parts.reduce(function (acc, part) {
    return acc.concat(separators.length ? [separators.shift()] : [], part.replace(validParts, ''), val[part.match(validParts)[0]][0](date, messages, noUTC));
  }, []);
  return formattedDate.join('').replace(/\\([dDmLhMy])/g, '$1');
}

var now = function now() {
  return new Date();
};

function parseDate(str, possibleDate, format, messages, failOnFormat) {
  if (!str) return possibleDate;
  var separators = format.replace(escapedValidParts, '\0').split('\0');
  var parts = format.match(escapedValidParts);
  var mutations = [];
  parts.reduce(function (rest, part, i) {
    var separator = (separators.length ? separators.shift() : '') + part.replace(validParts, '');
    var current = rest.slice(separator.length);

    if (current && separator === rest.slice(0, separator.length)) {
      var setType = part.match(validParts)[0];
      var nextSeparator = separators[0];
      var nextStrIndex = current.indexOf(nextSeparator + (parts[i + 1] || '').replace(validParts, ''));
      mutations[val[setType][2]] = [val[setType][1], nextStrIndex ? current.slice(0, nextStrIndex) : current];
      return current.slice(nextStrIndex);
    } else {
      return '';
    }
  }, str);
  var date = possibleDate && possibleDate.getTime() !== -1 ? new Date(possibleDate) : now();
  mutations.forEach(function (_ref) {
    var _ref2 = _slicedToArray__default['default'](_ref, 2),
        setter = _ref2[0],
        text = _ref2[1];

    return setter(text, date, messages, failOnFormat);
  });
  return date;
}

var isNotSelector = function isNotSelector(v) {
  return typeof v !== 'function' || v.length === 0;
};

var toSelector = function toSelector(v) {
  return isNotSelector(v) ? function (s) {
    return get(callIfFunction(v), s);
  } : v;
};

var mergeSelectors = function mergeSelectors(prev, next) {
  return function (v) {
    return next(prev(v));
  };
};

var concatSelectors = function concatSelectors() {
  for (var _len = arguments.length, paths = new Array(_len), _key = 0; _key < _len; _key++) {
    paths[_key] = arguments[_key];
  }

  return paths.reduce(function (_ref, path) {
    var _ref2 = _slicedToArray__default['default'](_ref, 2),
        selector = _ref2[0],
        isSelector = _ref2[1];

    return isNotSelector(path) && !isSelector ? [selector.concat(path), false] : [mergeSelectors(toSelector(selector), path), true];
  }, [[], false]);
};
var COMPLETE_ACTION = {};
var REDUCE = {};
var FETCH = {};
var SKIP_FETCH = {};
var SKIP_DISPATCH = {};
var SKIPPED_ACTION = {};
var selectPath = function selectPath(useState) {
  for (var _len2 = arguments.length, paths = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    paths[_key2 - 1] = arguments[_key2];
  }

  var _useMemo = react.useMemo(function () {
    return concatSelectors.apply(void 0, paths);
  }, paths),
      _useMemo2 = _slicedToArray__default['default'](_useMemo, 1),
      selector = _useMemo2[0];

  var _useState = useState(selector),
      _useState2 = _slicedToArray__default['default'](_useState, 1),
      value = _useState2[0];

  return value;
};
var Action = function Action(fnOrArray) {
  var prevArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isArray = Array.isArray(fnOrArray);

  if (isArray) {
    // excessive paramaeters called on the action, used for options.
    var actionType = _last__default['default'](prevArgs);

    var _fnOrArray = _slicedToArray__default['default'](fnOrArray, 3),
        fetcher = _fnOrArray[0],
        reducer = _fnOrArray[1],
        rollbacker = _fnOrArray[2];

    if (actionType === REDUCE) {
      return reducer(null, prevArgs);
    } else if (actionType === FETCH) {
      return fetcher();
    } else {
      return _set__default['default']('extra', fnOrArray.extra, [actionType === SKIP_FETCH ? function () {
        return Promise.resolve();
      } : fetcher, actionType === SKIP_DISPATCH ? undefined : reducer].concat(rollbacker || []));
    }
  } else {
    return prevArgs.length < fnOrArray.length ? function () {
      for (var _len3 = arguments.length, moreArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        moreArgs[_key3] = arguments[_key3];
      }

      return Action(fnOrArray, _toConsumableArray__default['default'](prevArgs).concat(moreArgs));
    } : Action(fnOrArray.apply(void 0, _toConsumableArray__default['default'](prevArgs)), prevArgs);
  }
};

var mapAction = function mapAction(get, dispatcher, firstRun) {
  return function (action) {
    if (Array.isArray(action)) {
      if (firstRun) {
        return function () {
          return mapAction(get, dispatcher)(action);
        };
      }

      var _action = _slicedToArray__default['default'](action, 3),
          fetcher = _action[0],
          reducer = _action[1],
          rollbacker = _action[2];

      var _ref3 = action.extra || {},
          skip = _ref3.skip;

      if (skip && skip(get())) {
        return Promise.resolve(SKIPPED_ACTION);
      }

      var fetched = fetcher();

      if (rollbacker) {
        dispatcher(function (prevState) {
          var nextState = reducer(null)(prevState);
          fetched.catch(function (response) {
            dispatcher(rollbacker(prevState, nextState, response));
          });
          return nextState;
        });
      }

      if (reducer !== undefined) {
        fetched.then(function (response) {
          return dispatcher(reducer(response));
        });
      }

      return fetched;
    } else {
      return function () {
        return mapAction(get, dispatcher)(action.apply(void 0, arguments));
      };
    }
  };
};

var activateActions = function activateActions(get, dispatcher) {
  for (var _len4 = arguments.length, actions = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
    actions[_key4 - 2] = arguments[_key4];
  }

  return actions.map(mapAction(get, dispatcher, true));
};
var SkipAction = function SkipAction(skip, action) {
  action.extra = _objectSpread__default['default']({}, action.extra, {
    skip: skip
  });
  return action;
};

var compareBest = function compareBest(compare) {
  return function (best, next) {
    return best ? compare(best, next) ? next : best : next;
  };
};
var toLowest = function toLowest() {
  var getValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _identity__default['default'];
  return compareBest(function (best, next) {
    return getValue(next) < getValue(best);
  });
};
var toHighest = function toHighest() {
  var getValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _identity__default['default'];
  return compareBest(function (best, next) {
    return getValue(next) > getValue(best);
  });
};

var useEventListener = function useEventListener(eventName, callback) {
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  react.useEffect(function () {
    window.addEventListener(eventName, callback);
    return function () {
      return window.removeEventListener(eventName, callback);
    };
  }, deps);
};
var useEventListenerFor = function useEventListenerFor(element, eventName, callback) {
  var deps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  react.useEffect(function () {
    element.addEventListener(eventName, callback);
    return function () {
      return element.removeEventListener(eventName, callback);
    };
  }, deps.concat(element));
};

// a contract like this to integrate with React.
// Real implementations can be significantly more complex.
// Don't copy-paste this into your project!

var EMPTY_ARGS = [];
var UNDEFINED_CURRENT_VALUE = {};

var innerWrapLazy = function innerWrapLazy(refreshCallback) {
  return function (promise) {
    for (var _len = arguments.length, rootArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rootArgs[_key - 1] = arguments[_key];
    }

    var status;
    var lazyResolver;
    var lazyPromise;
    var lazyArgs = EMPTY_ARGS;

    var _uid = Math.random().toString() + Date.now();

    var result;
    var currentValue = UNDEFINED_CURRENT_VALUE;

    var suspend = function suspend(promise) {
      status = "pending";
      lazyResolver = _identity__default['default'];
      lazyPromise = _isFunction__default['default'](promise) ? new Promise(function (res) {
        return lazyResolver = res;
      }) : Promise.resolve();
      var returnedPromise = lazyPromise.then(function () {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return callIfFunction.apply(void 0, [promise].concat(rootArgs, _toConsumableArray__default['default'](lazyArgs), args)).then(function (r) {
          if (returnedPromise !== suspender) {
            return suspender;
          }

          status = "success";
          currentValue = r;
          result = r;
          return r;
        }, function (e) {
          if (returnedPromise === suspender) {
            return suspender;
          }

          status = "error";
          result = e;
        });
      });
      return returnedPromise;
    };

    var suspender = suspend(promise);
    return {
      read: function read() {
        lazyResolver();

        if (status === "pending") {
          throw suspender;
        } else if (status === "error") {
          throw result;
        } else if (status === "success") {
          return result;
        }
      },
      promise: function promise() {
        lazyResolver();
        return suspender;
      },
      refresh: function refresh() {
        suspender = suspend(promise);
        _uid = Math.random().toString() + Date.now();
        callIfFunction(refreshCallback, this);
        return this;
      },
      next: function next() {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return wrapLazy.apply(void 0, [promise].concat(rootArgs, args));
      },
      use: function use() {
        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        if (!_isEqual__default['default'](args, lazyArgs)) {
          if (lazyArgs !== EMPTY_ARGS) {
            _uid = Math.random().toString() + Date.now();
          }

          lazyArgs = args;
          suspender = suspend(promise);
        }

        return this;
      },
      _getCurrentValue: function _getCurrentValue() {
        return currentValue;
      },
      and: function and(lazy) {},
      uid: function uid() {
        return _uid;
      }
    };
  };
};

var UNMOUNTED = {};
var wrapLazy = innerWrapLazy();
var willUseLazy = function willUseLazy() {
  var promiseCallbackRef = {
    current: null
  };
  var promiseRef = {
    current: new Promise(function (res) {
      return promiseCallbackRef.current = res;
    })
  };

  var useLazyEffect = function useLazyEffect(callback) {
    var value = lazy._getCurrentValue();

    var componentState = react.useRef(value);
    react.useEffect(function () {
      var callbackCaller = function callbackCaller(result) {
        if (componentState.current !== UNMOUNTED) {
          componentState.current = result;
          callback(result);
          promiseRef.current.then(callbackCaller);
        }
      };

      promiseRef.current.then(callbackCaller);
      return function () {
        return componentState.current = UNMOUNTED;
      };
    }, []);
    react.useEffect(function () {
      if (value !== componentState.current) {
        callback(value);
      }
    }, [value]);
  };

  var lazy = innerWrapLazy(function (lazy) {
    lazy.promise().then(function (result) {
      var tempCallback = promiseCallbackRef.current;
      promiseRef.current = new Promise(function (res) {
        return promiseCallbackRef.current = res;
      });
      tempCallback(result);
    });
  }).apply(void 0, arguments);
  return [lazy, useLazyEffect];
};
var willUseAutoLazy = function willUseAutoLazy() {
  var _willUseLazy = willUseLazy.apply(void 0, arguments),
      _willUseLazy2 = _slicedToArray__default['default'](_willUseLazy, 2),
      lazy = _willUseLazy2[0],
      useLazyEffect = _willUseLazy2[1];

  var useAutoLazyEffect = function useAutoLazyEffect(extraEffect) {
    var _useState = react.useState(1),
        _useState2 = _slicedToArray__default['default'](_useState, 2),
        update = _useState2[1];

    useLazyEffect(function () {
      return update(function (i) {
        return i + 1;
      });
    });
  };

  return [lazy, useAutoLazyEffect];
};

exports.Action = Action;
exports.COMPLETE_ACTION = COMPLETE_ACTION;
exports.FETCH = FETCH;
exports.REDUCE = REDUCE;
exports.SKIPPED_ACTION = SKIPPED_ACTION;
exports.SKIP_DISPATCH = SKIP_DISPATCH;
exports.SKIP_FETCH = SKIP_FETCH;
exports.SkipAction = SkipAction;
exports._s = _s;
exports.activateActions = activateActions;
exports.addHttp = addHttp;
exports.addQueryString = addQueryString;
exports.animationTiming = animationTiming;
exports.callIfFunction = callIfFunction;
exports.callIfFunctions = callIfFunctions;
exports.callMany = callMany;
exports.compareBest = compareBest;
exports.concatSelectors = concatSelectors;
exports.constrainEvent = constrainEvent;
exports.createPromiseQueue = createPromiseQueue;
exports.customTheme = customTheme;
exports.digitsToPattern = digitsToPattern;
exports.ellipsis = ellipsis;
exports.fixMediaQuery = fixMediaQuery;
exports.formFetch = formFetch;
exports.formFetchWithResponse = formFetchWithResponse;
exports.formatDate = formatDate;
exports.formatDateToPattern = formatDateToPattern;
exports.formatPath = formatPath;
exports.getClosestOffsetScroll = getClosestOffsetScroll;
exports.getColor = getColor;
exports.getFetcher = getFetcher;
exports.getFetcherWithResponse = getFetcherWithResponse;
exports.getMargin = getMargin;
exports.getNumberInputType = getNumberInputType;
exports.getNumberInputType2 = getNumberInputType2;
exports.getProp = getProp;
exports.getScrollParent = getScrollParent;
exports.getUID = getUID;
exports.getUrlParams = getUrlParams;
exports.identityFn = identityFn;
exports.identityOpacityFrames = identityOpacityFrames;
exports.identityTranslateFrames = identityTranslateFrames;
exports.ifProp = ifProp;
exports.ifUndefined = ifUndefined;
exports.intToHour = intToHour;
exports.intsToHour = intsToHour;
exports.isEmptyHtml = isEmptyHtml;
exports.isHighDensity = isHighDensity;
exports.isIOS = isIOS;
exports.isMobile = isMobile;
exports.isRetina = isRetina;
exports.isSmallDevice = isSmallDevice;
exports.isTouchDevice = isTouchDevice;
exports.isUrl = isUrl;
exports.lazyValue = lazyValue;
exports.linkRegex = linkRegex;
exports.mapGetOrSet = mapGetOrSet;
exports.media = media;
exports.normalizeMouse = normalizeMouse;
exports.normalizeTouch = normalizeTouch;
exports.oneWayAnimation = oneWayAnimation;
exports.parseDate = parseDate;
exports.postFetcher = postFetcher;
exports.postFetcherWithResponse = postFetcherWithResponse;
exports.preventDefault = preventDefault;
exports.rafThrottle = rafThrottle;
exports.safeNewLineToBr = safeNewLineToBr;
exports.scrollIntoViewWithOffset = scrollIntoViewWithOffset;
exports.scrollWidth = scrollWidth;
exports.selectPath = selectPath;
exports.smoothScroll = smoothScroll;
exports.stopPropagation = stopPropagation;
exports.styledExtend = styledExtend;
exports.timerPromise = timerPromise;
exports.toHighest = toHighest;
exports.toLowest = toLowest;
exports.twoWayAnimation = twoWayAnimation;
exports.unWill = unWill;
exports.useEventListener = useEventListener;
exports.useEventListenerFor = useEventListenerFor;
exports.using = using;
exports.will = will;
exports.willRafThrottle = willRafThrottle;
exports.willUseAutoLazy = willUseAutoLazy;
exports.willUseLazy = willUseLazy;
exports.wrapLazy = wrapLazy;
